import { render } from "./bar_chart.vue?vue&type=template&id=565006dd"
import script from "./bar_chart.vue?vue&type=script&lang=js"
export * from "./bar_chart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/chart/bar_chart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "565006dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('565006dd', __exports__)) {
    api.reload('565006dd', __exports__)
  }
  
  module.hot.accept("./bar_chart.vue?vue&type=template&id=565006dd", () => {
    api.rerender('565006dd', render)
  })

}


export default __exports__